<script>
let syncfusionCss = {};
</script>

<style lang="scss">
$accent: #1976d2;
/*@import "~@syncfusion/ej2/material.scss";*/
@import "~@syncfusion/ej2-base/styles/material.scss";
@import "~@syncfusion/ej2-vue-buttons/styles/material.scss";
@import "~@syncfusion/ej2-vue-popups/styles/material.scss";
@import "~@syncfusion/ej2-vue-notifications/styles/material.scss";
@import '~@syncfusion/ej2-vue-layouts/styles/material.scss';
/* #js-licensing {
    display: none !important;
} */
.e-grid-min-height .e-rowcell {
    line-height: normal !important;
}
</style>

<style lang="scss">
.apply-bootstrap {
    @import "~bootstrap-css-only/css/bootstrap-grid.min";
}

body {
    margin: 0px;
    padding: 0px;
}

.apply-bootstrap .container-fluid,
.apply-bootstrap .container-lg,
.apply-bootstrap .container-md,
.apply-bootstrap .container-sm,
.apply-bootstrap .container-xl {
    padding: 0px !important;
}

.apply-bootstrap .alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}

*,
*::before,
*::after {
    box-sizing: border-box;
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
    clip: auto;
    white-space: normal;
}
</style>
